let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jVOBG")).then(() => parcelRequire('fyJfi'));